import Errors from './Errors'
import axios from 'axios'
import router from '../router'

/**
 * Define a "Resource" that is responsible for fetching,
 * posting, patching and putting to the API
 */
class ApiResource {
  /**
   * Constructor. Pass Form data as a constructor parameter.
   * Key/Value pair expected
   *
   * @param {object} data The form data to pass through to the new instance
   *
   * @return {void}
   */
  constructor (data) {
    this.originalData = data

    for (let field in data) {
      this[field] = data[field]
    }

    this.errors = new Errors()
  }

  /**
   * Return data object for the form
   *
   * @returns {object}
   */
  data () {
    let data = {}

    for (let property in this.originalData) {
      data[property] = this[property]
    }

    return data
  }

  /**
   * Clear form fields and any errors
   *
   * @returns {void}
   */
  reset () {
    for (let field in this.originalData) {
      this[field] = ''
    }

    this.errors.clear()
  }

  /**
   * Fetch a resource from API by URL path
   * @param  {string} path URL string
   * @return {void}
   */
  fetch (path) {
    axios.get(path)
      .then(this.success.bind(this))
      .catch(this.fail.bind(this))
  }

  /**
   * Make a POST or PUT or PATCH request
   * @param {string} path The remote API endpoint
   * @param {object} data The data to send to the endpoint
   * @param {string} type The type has to be either POST or PATCH or PUT
   * @return {Promise}
   */
  send (path, data = this.data(), type = 'post') {
    return new Promise((resolve, reject) => {
      axios[type](path, data)
        .then(response => {
          this.success(response.data)
          resolve(response.data)
        })
        .catch(error => {
          let errorObject = error
          // token expired or guest?
          if (error.response.status === 401) {
            router.push('/login')
          } else {
            errorObject = error.response.data
          }

          this.fail(errorObject, error.response.status)
          reject(errorObject)
        })
    })
  }

  /**
   * This method to be called when we have a successful HTTP
   * status code. Pass the response here and assign to the
   * instance data object
   *
   * @param  {object} data Response object
   *
   * @return {void}
   */
  success (data) {
    this.reset()
    for (let field in data) {
      this[field] = data[field]
    }
  }

  /**
   * Error status code returned from API
   * Assign the response message(s) to the errors object
   *
   * @param  {object} errors Response object
   * @param  {number} status HTTP status code
   *
   * @return {void}
   */
  fail (errors, status = 0) {
    this.errors.record(errors)
    if (status > 0) {
      this.errors.setStatus(status)
    }
  }
}

export { ApiResource as default }



// WEBPACK FOOTER //
// ./src/api/ApiResource.js